<template>
  <div class="w-full">
    <div class="flex justify-between items-center">
      <Back />
      <router-link 
        :to="'/classroom/' + classroomId + '/detail'"
        class="text-right text-blue-600 hover:text-blue-800 duration-300"
      >
        {{ classroom?.name }} ({{ classroom?.code }})
      </router-link>
    </div>
    <div class="grid gap-2 grid-cols lg:grid-cols-3">
      <div class="col-span-1 text-right">
        <span v-if="classroom?.is_must_subject" class="text-xs text-green-500"
          ><i class="fas fa-check"></i> Syarat kelulusan</span
        >
        <span v-else class="text-xs text-red-500"
          ><i class="fas fa-times"></i> Bukan syarat kelulusan</span
        >
        <router-link
          :to="'/classroom/' + classroomId + '/subject'"
          class="p-5 flex items-center justify-between bg-red-600 hover:bg-red-700 text-white rounded-md font-semibold shadow-md duration-300"
        >
          <span
            ><i class="fas fa-file-video mr-2"></i>Video ({{
              videoList?.length ? videoList?.length : '0'
            }})</span
          >
          <i class="fas fa-arrow-right"></i>
        </router-link>
      </div>
      <div class="col-span-1 text-right">
        <span v-if="classroom?.is_must_module" class="text-xs text-green-500"
          ><i class="fas fa-check"></i> Syarat kelulusan</span
        >
        <span v-else class="text-xs text-red-500"
          ><i class="fas fa-times"></i> Bukan syarat kelulusan</span
        >
        <router-link
          :to="'/classroom/' + classroomId + '/modul'"
          class="p-5 flex items-center justify-between bg-yellow-600  hover:bg-yellow-700 rounded-md text-white font-semibold shadow-md duration-300"
        >
          <span
            ><i class="fas fa-book mr-2"></i>Modul ({{
              modulList?.length > 0 ? modulList?.length : '0'
            }})</span
          >
          <i class="fas fa-arrow-right"></i>
        </router-link>
      </div>

      <div class="col-span-1 text-right">
        <span
          v-if="classroom?.is_must_quiz || classroom?.is_must_exam"
          class="text-xs text-green-500"
          ><i class="fas fa-check"></i> Syarat kelulusan</span
        >
        <span v-else class="text-xs text-red-500"
          ><i class="fas fa-times"></i> Bukan syarat kelulusan</span
        >
        <router-link
          :to="'/classroom/' + classroomId + '/quiz'"
          class="p-5 flex items-center justify-between bg-green-600 hover:bg-green-700 text-white rounded-md font-semibold shadow-md duration-300"
        >
          <span
            ><i class="fas fa-tasks mr-2"></i>Quiz dan Ujian ({{
              quizList?.length > 0 ? quizList?.length : '0' 
            }})</span
          >
          <i class="fas fa-arrow-right"></i>
        </router-link>
      </div>
    </div>
    <div
      v-if="
        duplicateMaterial?.length > 0
      "
      class="mt-2 border-t border-b px-4 py-3 bg-red-100 border-red-500 text-red-700"
      role="alert"
    >
      <p class="font-bold">
        Materi Terdeteksi Duplikat
      </p>
      <ul class="list-disc list-inside">
        <li 
          v-for="(dup, i) in duplicateMaterial"
          :key="i"
          class="text-sm"
        >
          Pada Materi <span class="text-sm font-medium">{{ dup.materi }}</span>, Sub-Materi <span class="text-sm font-medium">{{ dup.name }}</span>.
        </li>
      </ul>
    </div>
    <div
      v-if="
        !isLoading
      "
      class="mt-2 border-t border-b px-4 py-3"
      :class="
        !isMaterialExist
        ? 'bg-blue-100 border-blue-500 text-blue-700'
        : isVideoNotYetIncluded || isModuleNotYetIncluded || isQuizNotYetIncluded
          ? 'bg-yellow-100 border-yellow-500 text-yellow-700'
          : 'bg-green-100 border-green-500 text-green-700'
      "
      role="alert"
    >
      <p class="font-bold">
        {{
          !isMaterialExist
          ? "Belum ada Sub-Materi yang bisa ditambahkan"
          : isVideoNotYetIncluded ||
            isModuleNotYetIncluded ||
            isQuizNotYetIncluded
              ? "Materi Belum Komplit"
              : "Materi Sudah Komplit"
        }}
      </p>
      <p class="text-sm">{{ messageMaterialStatus }}</p>
    </div>
    <div class="flex justify-between my-3">
      <p class="self-center">Daftar Materi</p>
      <a
        type="button"
        @click="addNewMaterial"
        class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 sm:ml-3 sm:w-auto sm:text-sm"
      >
        Tambah Materi
      </a>
    </div>
    <DataTable
      :value="materials"
      dataKey="id"
      responsiveLayout="scroll"
      :rowHover="true"
      class="shadow p-datatable-sm font-sans text-sm mt-5"
      @rowExpand="onRowExpand"
      @rowReorder="onRowReorder"
      v-model:expandedRows="selectedMaterial"
    >
      <template #empty>
        <div class="text-center">
          Belum ada materi yang ditambahkan
        </div>
      </template>
      <Column
        :rowReorder="true"
        headerStyle="width: 1rem"
        :reorderableColumn="false"
        bodyClass="cursor-move"
      />
      <Column
        field="ordering"
        headerStyle="width: 5rem; text-align: center!important;"
        bodyStyle="text-align: center!important;"
        header="Urutan"
      ></Column>
      <Column
        :expander="true"
        headerStyle="width: 6rem"
        bodyStyle="text-align: center!important;"
        header="Sub-Materi"
      />
      <Column field="name" header="Nama Materi">
        <template #body="{data}">
          {{ data.name }}
        </template>
      </Column>
      <Column field="" headerStyle="width: 90px;" header="Aksi">
        <template #body="{data}">
          <a
            v-tooltip.top="'Edit'"
            @click.prevent="updateMaterial(data)"
            type="button"
            class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm p-2 bg-yellow-500 text-base font-medium text-white hover:bg-yellow-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:w-auto sm:text-sm"
          >
            <i class="fas fa-edit"></i>
          </a>
          <a
            v-tooltip.top="'Hapus'"
            @click.prevent="showDeleteMaterial(data)"
            type="button"
            class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm p-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 ml-2 sm:w-auto sm:text-sm"
          >
            <i class="fas fa-trash-alt"></i>
          </a>
        </template>
      </Column>
      <template #expansion="slotProps">
        <DataTable
          :value="slotProps.data.material"
          responsiveLayout="scroll"
          dataKey="id"
          :rowHover="true"
          @rowReorder="onRowReorderSub"
          class="p-datatable-sm font-sans text-sm m-0 p-0 border border-gray-200"
        >
          <template #header>
            <div class="flex items-center justify-between">
              <p class="text-base">{{ slotProps.data.name }}</p>
              <button
                @click="addNewMaterialItem(slotProps.data.id)"
                class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-sm text-white bg-indigo-600 hover:bg-indigo-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 sm:ml-3 sm:w-auto sm:text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                :disabled="
                  !isVideoNotYetIncluded &&
                    !isModuleNotYetIncluded &&
                    !isQuizNotYetIncluded
                "
              >
                Tambah Sub-materi
              </button>
            </div>
          </template>
          <template #empty>
            <div class="text-center">
              Belum ada sub-materi yang ditambahkan
            </div>
          </template>
          <Column
            :rowReorder="true"
            headerStyle="width: 1rem"
            :reorderableColumn="false"
            bodyClass="cursor-move"
          />
          <Column
            field="data.ordering"
            headerStyle="width: 5rem; text-align: center!important;"
            bodyStyle="text-align: center!important;"
            header="Urutan"
          />
          <Column field="data.name" header="Nama Sub-Materi">
            <template #body="{data}">
              <span
                v-if="data?.type == 'video'"
                @click="openVideoPreview(data.data)"
                class="text-blue-600 hover:text-blue-700 cursor-pointer"
              >
                {{ data.data.name }}
              </span>
              <span
                v-else-if="data?.type == 'module'"
                @click="openModulePreview(data.data)"
                class="text-blue-600 hover:text-blue-700 cursor-pointer"
              >
                {{ data.data.name }}
              </span>
              <router-link
                v-else
                :to="'/classroom/' + classroomId + '/quiz?quiz_id=' + data.data.id"
                class="text-blue-600 hover:text-blue-700 cursor-pointer"
              >
                {{ data.data.name }}
              </router-link>
            </template>
          </Column>
          <Column field="data.type" headerStyle="width: 8rem;" header="Tipe">
            <template #body="{data}">
              <span
                v-if="data?.type == 'video'"
                class="relative inline-block px-3 py-1 font-semibold text-red-700 leading-tight"
              >
                <span
                  aria-hidden
                  class="absolute inset-0 bg-red-400 opacity-50 rounded"
                ></span>
                <span class="relative">Video</span>
              </span>
              <span
                v-else-if="data?.type == 'quiz'"
                class="relative inline-block px-3 py-1 font-semibold text-green-700 leading-tight"
              >
                <span
                  aria-hidden
                  class="absolute inset-0 bg-green-400 opacity-50 rounded"
                ></span>
                <span class="relative">Quiz</span>
              </span>
              <span
                v-else
                class="relative inline-block px-3 py-1 font-semibold text-yellow-700 leading-tight"
              >
                <span
                  aria-hidden
                  class="absolute inset-0 bg-yellow-400 opacity-50 rounded"
                ></span>
                <span class="relative">Modul</span>
              </span>
            </template>
          </Column>
          <Column field="" headerStyle="width: 100px;" header="Aksi">
            <template #body="{data}">
              <a
                v-tooltip.top="'Hapus'"
                @click.prevent="showDeleteMaterialItem(slotProps.data.id, data)"
                type="button"
                class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm p-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 ml-2 sm:w-auto sm:text-sm"
              >
                <i class="fas fa-trash-alt"></i>
              </a>
            </template>
          </Column>
        </DataTable>
      </template>
    </DataTable>

    <!-- modal material -->
    <transition name="pop">
      <div
        v-if="displayModalMaterial"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
      >
        <div class="relative w-3/4 md:w-1/3 my-6 mx-auto">
          <div
            class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none"
          >
            <div
              class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700"
            >
              <h3 class="text-xl font-semibold text-white">
                {{ materialId > 0 ? "Ubah Materi" : "Tambah Materi" }}
              </h3>
              <button
                class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                v-on:click="closeModalMaterial"
              >
                <i
                  class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"
                ></i>
              </button>
            </div>
            <div class="relative px-6 pt-3 pb-6">
              <div class="w-full pb-3">
                <label
                  for="question"
                  class="block text-sm font-medium text-gray-700"
                >
                  Nama Materi<span class="text-red-600 font-bold">*</span>
                </label>
                <div class="mt-1">
                  <textarea
                    v-model="formMaterial.name"
                    type="text"
                    autocomplete="given-name"
                    placeholder="Nama Materi"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  ></textarea>
                </div>
              </div>
              <div class="text-right">
                <button
                  @click.prevent="submitMaterial"
                  class="inline-flex justify-center text-white border border-solid font-bold text-sm px-3 py-1.5 rounded outline-none focus:outline-none"
                  :class="
                    materialId > 0
                      ? 'bg-yellow-500 border-yellow-500 hover:bg-yellow-600 active:bg-yellow-600'
                      : 'bg-red-500 border-red-500 hover:bg-red-600 active:bg-red-600'
                  "
                  type="button"
                  style="transition: all .15s ease"
                >
                  {{ materialId > 0 ? "Ubah" : "Tambah" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- modal material item -->
    <transition name="pop">
      <div
        v-if="displayModalMaterialItem"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
      >
        <div class="relative w-3/4 md:w-1/3 my-6 mx-auto">
          <div
            class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none"
          >
            <div
              class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700"
            >
              <h3 class="text-xl font-semibold text-white">
                {{
                  materialItemId > 0 ? "Ubah Sub-Materi" : "Tambah Sub-Materi"
                }}
              </h3>
              <button
                class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                v-on:click="closeModalMaterialItem"
              >
                <i
                  class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"
                ></i>
              </button>
            </div>
            <div class="relative px-6 pt-3 pb-6">
              <div class="w-full pb-3">
                <label
                  for="type"
                  class="block text-sm font-medium text-gray-700"
                  >Pilih Tipe Sub-Materi</label
                >
                <Dropdown
                  class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm text-xs border-gray-300 rounded-md"
                  v-model="formMaterialItem.type"
                  @change="changeType($event)"
                  :options="materiOption"
                  placeholder="Pilih Tipe"
                  :showClear="true"
                />
              </div>

              <div v-if="formMaterialItem.type" class="w-full pb-3">
                <div class="flex justify-between items-center">
                  <label
                    for="question"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Pilih
                    {{
                      formMaterialItem.type == "video"
                        ? "Materi Video"
                        : formMaterialItem.type == "module"
                        ? "Materi Modul"
                        : "Quiz"
                    }}
                  </label>
                </div>
                <div class="mt-0">
                  <Dropdown
                    v-if="formMaterialItem.type == 'video'"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm text-xs border-gray-300 rounded-md"
                    v-model="selectedMaterialItem"
                    :options="videoFilter"
                    optionLabel="title"
                    placeholder="Pilih Video"
                    :filter="true"
                    :showClear="true"
                  />
                  <Dropdown
                    v-if="formMaterialItem.type == 'module'"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm text-xs border-gray-300 rounded-md"
                    v-model="selectedMaterialItem"
                    :options="moduleFilter"
                    optionLabel="title"
                    placeholder="Pilih Modul"
                    :filter="true"
                    :showClear="true"
                  />
                  <Dropdown
                    v-if="formMaterialItem.type == 'quiz'"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 w-full shadow-sm text-xs border-gray-300 rounded-md"
                    v-model="selectedMaterialItem"
                    :options="quizFilter"
                    optionLabel="name"
                    placeholder="Pilih Quiz"
                    :filter="true"
                    :showClear="true"
                  />
                </div>
              </div>
              <div class="text-right mt-5">
                <button
                  @click.prevent="submitMaterialItem"
                  class="inline-flex justify-center text-white border border-solid font-bold text-sm px-3 py-1.5 rounded outline-none focus:outline-none"
                  :class="
                    materialItemId > 0
                      ? 'bg-yellow-500 border-yellow-500 hover:bg-yellow-600 active:bg-yellow-600'
                      : 'bg-red-500 border-red-500 hover:bg-red-600 active:bg-red-600'
                  "
                  type="button"
                  style="transition: all .15s ease"
                >
                  {{ materialItemId > 0 ? "Ubah" : "Tambah" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- modal preview -->
    <transition name="pop">
      <div
        v-if="modalVideoPreview"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
      >
        <div class="relative w-3/4 md:w-1/2 my-6 mx-auto">
          <div
            v-click-away="closeVideoPreview"
            class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none"
          >
            <div
              class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700"
            >
              <h3 class="text-xl font-semibold text-white">
                Video Preview
              </h3>
              <button
                class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                v-on:click="closeVideoPreview()"
              >
                <i
                  class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"
                ></i>
              </button>
            </div>
            <div class="relative px-6 pt-3 pb-6">
              <div class="w-full pb-2">
                <span class="font-bold">
                  {{ selectedVideo?.name }}
                </span>
              </div>
              <div class="w-full pb-3">
                <div v-if="selectedVideo?.link.includes('iframe')" v-safe-html="selectedVideo?.link"></div>
                <vue-plyr v-else>
                  <video controls playsinline>
                    <source :src="selectedVideo?.link" />
                  </video>
                </vue-plyr>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- modal preview -->
    <transition name="pop">
      <div
        v-if="modalModulePreview"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
      >
        <div class="relative w-3/4 md:w-1/2 my-6 mx-auto h-5/6">
          <div
            v-click-away="closeModulePreview"
            class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full h-full bg-white outline-none focus:outline-none"
          >
            <div
              class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700"
            >
              <h3 class="text-xl font-semibold text-white">
                Modul Preview
              </h3>
              <button
                class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                v-on:click="closeModulePreview()"
              >
                <i
                  class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"
                ></i>
              </button>
            </div>
            <div class="relative px-6 pt-3 pb-6 h-full mb-3">
              <div class="w-full pb-2">
                <span class="font-bold">
                  {{ selectedModule?.name }}
                </span>
              </div>
              <div class="w-full h-full pb-3">
                <iframe :src="selectedModule?.link" width="100%" height="100%">
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <Delete
      :display="displayDeleteMaterial"
      title="Delete Materi?"
      :note="selectedMaterial?.name"
      :close="closeDeleteMaterial"
      :deleteBtn="deleteMaterial"
    />
    <Delete
      :display="displayDeleteMaterialItem"
      title="Delete Sub-Materi?"
      :note="selectedMaterialItem?.data?.name"
      :close="closeDeleteMaterialItem"
      :deleteBtn="deleteMaterialItem"
    />
    <Toast />
  </div>
</template>
<script>
/* eslint-disable */
import Back from "@/layout/Component/Back";
import { mapActions, mapGetters } from "vuex";
import { FilterMatchMode } from "primevue/api";
import Delete from "@/layout/Component/Delete";

export default {
  components: {
    Back,
    Delete,
  },
  data() {
    return {
      selectedMaterial: [],
      filters: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      classroomId: 0,
      displayModalMaterial: false,
      displayDeleteMaterial: false,
      displayModalMaterialItem: false,
      displayDeleteMaterialItem: false,
      materialId: 0,
      materialItemId: 0,
      formMaterial: {
        name: "",
        ordering: 0,
      },
      formMaterialItem: {
        type: "",
        item: 0,
        ordering: 0,
      },
      selectedMaterialItem: null,
      videoFilter: [],
      moduleFilter: [],
      quizFilter: [],
      materiOption: [],
      isLoading: true,
      modalVideoPreview: false,
      modalModulePreview: false,
      selectedVideo: {},
      selectedModule: {},
    };
  },
  async created() {
    this.classroomId = this.$route.params.classroomId;
    if (this.classroomId && this.classroom?.id != this.classroomId) {
      await this.fetchDetailClassroom(this.classroomId);
    }
    await this.getAllMaterial();
    this.filterMaterial();
  },
  computed: {
    ...mapGetters([
      "classroom",
      "materials",
      "material",
      "savedIdClassroomMaterial",
      "loadingMaterial",
      "successMaterial",
      "messageMaterial",
      "videoList",
      "modulList",
      "quizList",
    ]),
    isVideoNotYetIncluded() {
      if (this.videoFilter?.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    isModuleNotYetIncluded() {
      if (this.moduleFilter?.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    isQuizNotYetIncluded() {
      if (this.quizFilter?.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    messageMaterialStatus() {
      let notIncluded = [];
      if (
        this.videoList?.length == 0 &&
        this.modulList?.length == 0 && 
        this.quizList?.length == 0
      ) {
        return "Silahkan tambah Video, Modul atau Quiz terlebih dahulu."
      } else {
        if (
          this.videoFilter?.length > 0 ||
          this.moduleFilter?.length > 0 ||
          this.quizFilter?.length > 0
        ) {
          if (this.videoFilter?.length > 0) {
            const video = this.videoFilter?.length + " Video";
            notIncluded.push(video);
          }
          if (this.moduleFilter?.length > 0) {
            const modul = this.moduleFilter?.length + " Modul";
            notIncluded.push(modul);
          }
          if (this.quizFilter?.length > 0) {
            const quiz = this.quizFilter?.length + " Quiz";
            notIncluded.push(quiz);
          }
          let text = "";
          text = [
            notIncluded.slice(0, -1).join(", "),
            notIncluded.slice(-1)[0],
          ].join(notIncluded?.length < 2 ? "" : " dan ");
          return "Ada " + text + " yang belum masuk ke dalam Sub-Materi.";
        } else {
          return "Semua Video, Modul dan Quiz sudah masuk ke dalam Sub-Materi.";
        }
      }
    },
    listMaterial() {
      let material = []
      if (this.materials?.length > 0) {
        this.materials.forEach(el => {
          if (el.material?.length > 0) {
            el.material.forEach(e => {
              material.push({
                ...e.data,
                materi: el.name,
              })
            })
          }
        })
      }
      return material
    },

    duplicateMaterial() {
      if (this.listMaterial?.length > 0) {
        const lookup = this.listMaterial.reduce((a, e) => {
          a[e.id] = ++a[e.id] || 0;
          return a;
        }, {});
        return this.listMaterial.filter(e => lookup[e.id])
      } else {
        return []
      }
    },

    isMaterialExist() {
      if (this.videoList?.length > 0 || this.modulList?.length > 0 || this.quizList?.length > 0) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    ...mapActions([
      "fetchDetailClassroom",
      "fetchAllMaterials",
      "createMaterial",
      "editMaterial",
      "removeMaterial",
      "fetchAllVideos",
      "fetchAllModuls",
      "fetchAllQuizzes",
      "createMaterialItem",
      "editMaterialItem",
      "removeMaterialItem",
    ]),
    onRowExpand(event) {
      this.selectedMaterial = this.selectedMaterial.filter(
        (el) => el.id == event.data.id
      );
    },
    onRowCollapse(event) {
      // this.$toast.add({severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000});
    },
    addNewMaterial() {
      this.displayModalMaterial = true;
      this.formMaterial.name = "";
      this.formMaterial.ordering = 0;
      this.materialId = 0;
    },
    updateMaterial(data) {
      this.displayModalMaterial = true;
      this.formMaterial.name = data.name;
      this.formMaterial.ordering = data.ordering;
      this.materialId = data.id;
    },
    closeModalMaterial() {
      this.materialId = 0;
      this.displayModalMaterial = false;
    },
    async submitMaterial() {
      if (this.formMaterial.name) {
        if (this.materialId == 0) {
          this.formMaterial.ordering = this.materials?.length + 1;
          const data = {
            classCode: this.classroom.code,
            payload: this.formMaterial,
          };
          await this.createMaterial(data);
          if (this.successMaterial) {
            this.closeModalMaterial();
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.messageMaterial,
              life: 1000,
            });
            await this.fetchAllMaterials(this.classroomId);
            this.filterMaterial();
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Failed",
              detail: this.messageMaterial,
              life: 1000,
            });
          }
        } else {
          const data = {
            id: this.materialId,
            payload: this.formMaterial,
          };
          await this.editMaterial(data);
          if (this.successMaterial) {
            this.closeModalMaterial();
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.messageMaterial,
              life: 1000,
            });
            await this.fetchAllMaterials(this.classroomId);
            this.filterMaterial();
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Failed",
              detail: this.messageMaterial,
              life: 1000,
            });
          }
        }
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Gagal",
          detail: "Nama materi harus diisi",
          life: 1000,
        });
      }
    },
    showDeleteMaterial(data) {
      this.materialId = data.id;
      this.selectedMaterial = data;
      this.displayDeleteMaterial = true;
    },
    closeDeleteMaterial() {
      this.materialId = 0;
      this.displayDeleteMaterial = false;
      this.selectedMaterial = null;
    },
    async deleteMaterial() {
      const indexDeleted = this.materials.findIndex(
        (el) => el.id == this.materialId
      );
      await this.removeMaterial(this.materialId);
      if (this.successMaterial) {
        this.closeDeleteMaterial();
        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: this.messageMaterial,
          life: 1000,
        });

        this.materials.splice(indexDeleted, 1);
        const effectedMaterial = [];
        this.materials.forEach(async (el, i) => {
          if (el.ordering == i + 1) {
            effectedMaterial.push(false);
          } else {
            effectedMaterial.push(true);
          }
        });

        const check = effectedMaterial.some((el) => el == true);
        if (check) {
          for (let i = 0; i < effectedMaterial?.length; i++) {
            if (effectedMaterial[i]) {
              const payload = {
                name: this.maerials[i]?.name,
                ordering: i + 1,
              };
              const data = {
                id: this.materials[i]?.id,
                payload: payload,
              };
              this.materials[i].ordering = i + 1;
              await this.editMaterial(data);
            }
          }
        }
        this.$toast.add({
          severity: "success",
          summary: "success",
          detail: "Berhasil dipindah",
          life: 1000,
        });
        await this.fetchAllMaterials(this.classroomId);
        this.filterMaterial();
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Failed",
          detail: this.messageMaterial,
          life: 1000,
        });
      }
    },
    async onRowReorder(event) {
      const effectedMaterial = [];
      this.materials.forEach(async (el, i) => {
        if (el.id == event.value[i].id) {
          effectedMaterial.push(false);
        } else {
          effectedMaterial.push(true);
        }
      });
      const check = effectedMaterial.some((el) => el == true);
      if (check) {
        for (let i = 0; i < effectedMaterial?.length; i++) {
          if (effectedMaterial[i]) {
            const payload = {
              name: event.value[i]?.name,
              ordering: i + 1,
            };
            const data = {
              id: event.value[i]?.id,
              payload: payload,
            };
            this.materials[i].ordering = i + 1;
            await this.editMaterial(data);
          }
        }
        await this.fetchAllMaterials(this.classroomId);
        this.filterMaterial();
        this.$toast.add({
          severity: "success",
          summary: "success",
          detail: "Berhasil dipindah",
          life: 1000,
        });
      }
    },
    addNewMaterialItem(id) {
      this.displayModalMaterialItem = true;
      this.materialId = id;
      this.materialItemId = 0;
      this.formMaterialItem.type = "";
      this.formMaterialItem.ordering = 0;
      this.formMaterialItem.item = 0;
      this.materiOption = [];
      if (this.isVideoNotYetIncluded) {
        this.materiOption.push("video");
      }
      if (this.isModuleNotYetIncluded) {
        this.materiOption.push("module");
      }
      if (this.isQuizNotYetIncluded) {
        this.materiOption.push("quiz");
      }
    },
    updateMaterialItem(id, data) {
      this.displayModalMaterial = true;
      this.materialId = id;
      this.materialItemId = data.data.material_id;
      this.formMaterialItem.type = data.type;
      this.formMaterialItem.ordering = data.data.ordering;
      this.formMaterialItem.item = data.data.id;
    },
    closeModalMaterialItem() {
      this.materialId = 0;
      this.materialItemId = 0;
      this.selectedMaterialItem = null;
      this.displayModalMaterialItem = false;
      this.formMaterialItem.type = "";
    },
    async changeType(event) {
      if (event.value == "video") {
        await this.fetchAllVideos(this.classroomId);
      } else if (event.value == "module") {
        await this.fetchAllModuls(this.classroomId);
      } else {
        await this.fetchAllQuizzes(this.classroomId);
      }
    },

    async getAllMaterial() {
      await Promise.all([
        this.fetchAllMaterials(this.classroomId),
        this.fetchAllVideos(this.classroomId),
        this.fetchAllModuls(this.classroomId),
        this.fetchAllQuizzes(this.classroomId),
      ]);
    },

    arrayRemove(arr, value) {
      return arr.filter((el) => {
        return el.id != value;
      });
    },

    filterMaterial() {
      this.isLoading = true;
      this.videoFilter = this.videoList;
      this.moduleFilter = this.modulList;
      this.quizFilter = this.quizList;
      if (this.materials?.length > 0) {
        this.materials.forEach((el) => {
          if (el.material?.length > 0) {
            el.material.forEach((e) => {
              if (e.type == "video") {
                this.videoFilter = this.arrayRemove(
                  this.videoFilter,
                  e.data.id
                );
              } else if (e.type == "quiz") {
                this.quizFilter = this.arrayRemove(this.quizFilter, e.data.id);
              } else {
                this.moduleFilter = this.arrayRemove(
                  this.moduleFilter,
                  e.data.id
                );
              }
            });
          }
        });
      }
      this.isLoading = false;
    },

    async submitMaterialItem() {
      if (this.formMaterialItem.type && this.selectedMaterialItem) {
        if (this.materialItemId == 0) {
          this.formMaterialItem.item = this.selectedMaterialItem.id;
          const findMaterial = this.materials?.filter(
            (e) => e.id == this.materialId
          );
          this.formMaterialItem.ordering = findMaterial[0]?.material?.length + 1;
          const data = {
            materialId: this.materialId,
            payload: this.formMaterialItem,
          };
          await this.createMaterialItem(data);
          if (this.successMaterial) {
            this.closeModalMaterialItem();
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.messageMaterial,
              life: 1000,
            });
            await this.fetchAllMaterials(this.classroomId);
            this.filterMaterial();
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Failed",
              detail: this.messageMaterial,
              life: 1000,
            });
          }
        } else {
          const data = {
            materialId: this.materialId,
            payload: this.formMaterialItem,
          };
          await this.editMaterialItem(data);
          if (this.successMaterial) {
            this.closeModalMaterialItem();
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.messageMaterial,
              life: 1000,
            });
            await this.fetchAllMaterials(this.classroomId);
            this.filterMaterial();
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Failed",
              detail: this.messageMaterial,
              life: 1000,
            });
          }
        }
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Gagal",
          detail: "Silahkan pilih sub-materi",
          life: 1000,
        });
      }
    },

    showDeleteMaterialItem(id, data) {
      this.materialId = id;
      this.materialItemId = data.data.material_id;
      this.selectedMaterialItem = data;
      this.displayDeleteMaterialItem = true;
    },
    closeDeleteMaterialItem() {
      this.materialId = 0;
      this.materialItemId = 0;
      this.selectedMaterialItem = null;
      this.displayDeleteMaterialItem = false;
    },

    async deleteMaterialItem() {
      const indexMateri = this.materials.find((el) => el.id == this.materialId);
      const indexDeletedItem = indexMateri.material.findIndex(
        (el) => el.data.material_id == this.materialItemId
      );
      if (indexMateri) {
      }
      await this.removeMaterialItem(this.materialItemId);
      if (this.successMaterial) {
        this.closeDeleteMaterialItem();
        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: this.messageMaterial,
          life: 1000,
        });

        indexMateri.material.splice(indexDeletedItem, 1);
        const effectedMaterial = [];
        if (indexMateri.material?.length > 0) {
          indexMateri.material.forEach(async (el, i) => {
            if (el.data.ordering == i + 1) {
              effectedMaterial.push(false);
            } else {
              effectedMaterial.push(true);
            }
          });
          const check = effectedMaterial.some((el) => el == true);
          if (check) {
            for (let i = 0; i < effectedMaterial?.length; i++) {
              if (effectedMaterial[i]) {
                const payload = {
                  type: indexMateri.material[i]?.type,
                  item: indexMateri.material[i]?.data?.id,
                  ordering: i + 1,
                };
                const data = {
                  materialItemId: indexMateri.material[i]?.data?.material_id,
                  payload: payload,
                };
                await this.editMaterialItem(data);
              }
            }
          }
          this.$toast.add({
            severity: "success",
            summary: "success",
            detail: "Berhasil dipindah",
            life: 1000,
          });
        }

        await this.fetchAllMaterials(this.classroomId);
        this.filterMaterial();
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Failed",
          detail: this.messageMaterial,
          life: 1000,
        });
      }
    },

    async onRowReorderSub(event) {
      const effectedMaterial = [];

      this.selectedMaterial[0].material.forEach(async (el, i) => {
        if (el.data.ordering == event.value[i].data.ordering) {
          effectedMaterial.push(false);
        } else {
          effectedMaterial.push(true);
        }
      });

      const check = effectedMaterial.some((el) => el == true);
      if (check) {
        for (let i = 0; i < effectedMaterial?.length; i++) {
          if (effectedMaterial[i]) {
            const payload = {
              type: event.value[i]?.type,
              item: event.value[i]?.data?.id,
              ordering: i + 1,
            };
            const data = {
              materialItemId: event.value[i]?.data?.material_id,
              payload: payload,
            };
            await this.editMaterialItem(data);
          }
        }
        await this.fetchAllMaterials(this.classroomId);
        this.filterMaterial();
        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: "Berhasil dipindah",
          life: 1000,
        });
      }
    },
    openVideoPreview(data) {
      this.modalVideoPreview = true
      this.selectedVideo = data
    },
    openModulePreview(data) {
      this.modalModulePreview = true
      this.selectedModule = data
    },
    closeVideoPreview() {
      this.modalVideoPreview = false
      this.selectedVideo = {}
    },
    closeModulePreview() {
      this.modalModulePreview = false
      this.selectedModule = {}
    },
  },
};
</script>

<style scoped>
/* ::v-deep(.p-datatable .p-column-header-content) {
  place-content: center;
} */
</style>
